export const TIK_TOK_ID = 285184;
export const DOUYIN_ID = 285185;
export const YOUTUBE_SHORTS_ID = 291943;
export const WESEE_ID = 289673;

export const defaultPlatforms = [
  { id: DOUYIN_ID, displayName: 'Douyin', name: 'douyin', color: '#1A6267' },
  { id: TIK_TOK_ID, displayName: 'TikTok', name: 'tiktok', color: '#1A6267' },
  { id: WESEE_ID, displayName: 'WeSee', name: 'wesee', color: '#5F39F3' },
  {
    id: YOUTUBE_SHORTS_ID,
    displayName: 'YouTube Shorts',
    name: 'youtubeShorts',
    color: '#FF0000',
  },
];

export const platformDefaultColor: any = {
  tiktok: {
    views: {
      ugc: '#1A6267',
      pgc: '#6DC9CF',
    },
    creations: {
      ugc: '#000000',
      pgc: '#EC0F55',
    },
  },
  douyin: {
    views: {
      ugc: '#1A6267',
      pgc: '#6DC9CF',
    },
    creations: {
      ugc: '#000000',
      pgc: '#EC0F55',
    },
  },
  wesee: {
    views: {
      ugc: '#5F39F3',
    },
    creations: {
      ugc: '#FC3EAF',
    },
  },
  youtubeShorts: {
    views: {
      ugc: '#FF0000',
    },
    creations: {
      ugc: '#212121',
    },
  },
};
